import {useCallback} from 'react';

import {trackPanelBankEvent} from '../../../services/analytics';
import {useViewActionBindAll} from '../../../state/views/hooks';
import * as PanelBankConfigActions from '../../../state/views/panelBankConfig/actions';
import {useWorkspaceRefsContext} from '../../Workspace/WorkspaceRefsContext';
import {useWorkspaceDrawerContext} from '../../WorkspaceDrawer/WorkspaceDrawerContextProvider';

export const useClearPanels = () => {
  const {closeWorkspaceDrawer} = useWorkspaceDrawerContext();
  const {panelBankConfigRef, workspaceSettingsRef} = useWorkspaceRefsContext();

  const clearAllPanels = useViewActionBindAll(
    PanelBankConfigActions.clearAllPanels,
    panelBankConfigRef,
    workspaceSettingsRef
  );

  return useCallback(() => {
    closeWorkspaceDrawer();
    trackPanelBankEvent({action: 'Clear all panels'});
    clearAllPanels();
  }, [clearAllPanels, closeWorkspaceDrawer]);
};
